// Percorso file: src/components/UserBar.jsx
//
// Barra utente comune a tutta l'app — doc 07 §7.1 (revisione 2A):
// logo del club nel cerchio bordato oro, nome ed email su due righe,
// Logout piccolo a destra.
//
// Il Logout usa `logout()` di AuthContext.
//
// ⚠️ LOGOUT SPENTO PER DEFAULT (cantiere LOGOUT-1, 26/9/2026). Il Logout
// ha lasciato la barra ed è l'ultima voce di More / Assistance
// (pages/legal/MorePage.jsx): chi ha una home con More esce da lì. La prop
// `showLogout` (default false, passata dal telaio HomeShell) lo riaccende
// IDENTICO a prima solo sulle schermate-VICOLO CIECO — quelle da cui, coi
// soli tocchi nell'app, non si arriva né a More né a un'altra schermata
// col Logout: attesa PENDING (HomePending), «Complete your details»
// (HomeIncomplete), le tre viste di SystemView (archiviato, accesso non
// consentito, ruolo non riconosciuto) e la home del guest (ClinicMember
// con `home`). REGOLA: ogni schermata-vicolo cieco nuova DEVE accenderla,
// o chi ci finisce resta chiuso dentro. La barra non legge né stato né
// ruolo per decidere: lo dice la pagina.

import React from "react";
import { useAuth } from "../context/AuthContext";
import "./UserBar.css";

const UserBar = ({ showLogout = false }) => {
  const { user, logout } = useAuth();

  // Un utente ARCHIVED riceve da AuthContext, all'ingresso, un oggetto
  // ridotto (firebaseUid, email, status): senza nome si mostra la sola
  // email. Non dura: ArchivedView, montata, rilegge il profilo completo
  // (`refreshUserFromBackend`) e da lì la barra mostra nome + email.
  const fullName = [user?.firstName, user?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  return (
    <header className="qpsc-userbar">
      <img
        className="qpsc-userbar__logo"
        src="/images/logo.png"
        alt="Queens Park Soccer Club"
      />

      <div className="qpsc-userbar__identity">
        {fullName && <span className="qpsc-userbar__name">{fullName}</span>}
        {user?.email && (
          <span className="qpsc-userbar__email">{user.email}</span>
        )}
      </div>

      {showLogout && (
        <button type="button" className="qpsc-userbar__logout" onClick={logout}>
          Logout
        </button>
      )}
    </header>
  );
};

export default UserBar;
